// extracted by mini-css-extract-plugin
export default {"resend-text":"ResendButton_resend-text__Z0svu","count-down":"ResendButton_count-down__xBDGZ"};